import { __exportAll } from "../../_virtual/_rolldown/runtime.js";
import { Group } from "./group.js";
import { Separator } from "./separator.js";
import { Value } from "./value.js";
//#region src/ui/time/index.parts.ts
var index_parts_exports = /* @__PURE__ */ __exportAll({
	Group: () => Group,
	Separator: () => Separator,
	Value: () => Value
});
//#endregion
export { Group, Separator, Value, index_parts_exports };

//# sourceMappingURL=index.parts.js.map